export default `---
slug: voice-cloning
title: "Voice Cloning and Fake Audio Detection"
year: 2023
category: personal
featured: false
tags: [Python, TTS, CNN, Speech Recognition, Transformers, Apziva]
thumbnail: /images/projects/18_vecho_TTS.png
description: "Clone a voice, generate fake audio, then train a CNN to detect it — 0.9988 F1 score (partly because the TIMIT dataset is a mess)."
relatedLinks:
  - label: "Apziva Data Science Bootcamp"
    href: /career/apziva-bootcamp
---

This is the sixth project I did with [Apziva](https://www.apziva.com/), a Data Science bootcamp that I attended for the most part of 2023.
Apziva provided me the dataset for the project, and a mentor whom I would have weekly meetings with, to support my progress. Except for Bhargav (my mentor), I did everything alone, *and with Claude, who am I kidding*.

This project ([GitHub repo](https://github.com/Ilvecho/Voice-Cloning-and-Fake-Audio-Detection)) covered Speech recognition and generation, a very interesting topic that I am happy to have discovered.

![Student in NL doing TTS](/images/projects/18_vecho_TTS.png)

In this project, I needed to create a system to recognize fake spoken audio.

- First of all, I had to create the dataset, so I leveraged the TTS library and pre-trained models to develop a voice cloning system, capable of generating fake audios from text and a voice sample
- I wanted to validate the data I generated, so I implemented the Speech2TextProcessor from the transformer library to identify text in the generated fake audios
- Based on the recognized text, I evaluated the Fake Audio generation pipeline using Word Error Rate (WER). The average WER in the generated fake audio was a mere 0.3
- Once I had the dataset, I engineered and trained a deep neural network with convoluted and dense layers to classify synthetically generated audio.
- Finally, I tested our model using the TIMIT dataset as ground truth and the generated Fake audios as target data points. The resulting F1 score is 0.9988, showcasing the model's robustness. *Or the fact that the generated audios had no background noise and the sound was quite clear, while the TIMIT dataset is a mess...*
- One of the complexities of this project was the handling of big (and memory heavy) quantity of data. But again, Google Colab did not disappoint.

It goes without saying that I did the project in Python, using Google computing power (*Colab one love*).
I would love to tell you more about the project, but I don't really remember and I am too lazy to check the Jupyter notebook - it is linked at the top, if you are curious go check it out!
`;
